module.exports = __webpack_public_path__ + "static/img/privacy_count.11bb1574.svg";